import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Skeleton, Text, VStack } from '@abb/uikit';
import { Clock } from '@abb/uikit/icons/solid/time';
import { REFERENCE_NUMBER_REGEX } from 'consts';
import { useDependencies, useGetAdvanceNotificationDetail, useMarkNotificationAsRead } from 'hooks';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import InfoIconBold from 'shared-components/icons/InfoIconBold';
export function AdvanceNotificationModal(param) {
    let { isOpen, onClose, notification } = param;
    var _notification_content;
    const { t } = useTranslation('common');
    const navigate = useNavigate();
    const { languageService } = useDependencies();
    const { putFunc } = useMarkNotificationAsRead();
    const extractedRefNumber = notification === null || notification === void 0 ? void 0 : (_notification_content = notification.content) === null || _notification_content === void 0 ? void 0 : _notification_content.match(REFERENCE_NUMBER_REGEX);
    const { data, isValidating, error } = useGetAdvanceNotificationDetail(extractedRefNumber === null || extractedRefNumber === void 0 ? void 0 : extractedRefNumber[0], isOpen && !!(extractedRefNumber === null || extractedRefNumber === void 0 ? void 0 : extractedRefNumber[0]));
    const handleMarkAsRead = (id, onSuccessEndRequest)=>{
        putFunc(id, languageService === null || languageService === void 0 ? void 0 : languageService.currentLanguage.toLocaleUpperCase(), onSuccessEndRequest);
    };
    return /*#__PURE__*/ _jsxs(Modal, {
        isOpen: isOpen,
        onClose: ()=>{
            const onSuccessEndRequest = ()=>{
                onClose();
            };
            handleMarkAsRead(notification === null || notification === void 0 ? void 0 : notification.id, onSuccessEndRequest);
        },
        isCentered: true,
        motionPreset: "slideInBottom",
        scrollBehavior: "inside",
        size: "lg",
        children: [
            /*#__PURE__*/ _jsx(ModalOverlay, {}),
            /*#__PURE__*/ _jsxs(ModalContent, {
                containerProps: {
                    px: 0
                },
                children: [
                    /*#__PURE__*/ _jsx(ModalCloseButton, {
                        "data-test-id": "close-button",
                        zIndex: "9999",
                        top: "20px",
                        right: "20px",
                        bg: "semantic.surface.secondary",
                        w: "40px",
                        h: "40px"
                    }),
                    /*#__PURE__*/ _jsx(ModalBody, {
                        px: 6,
                        py: 4,
                        children: /*#__PURE__*/ _jsxs(VStack, {
                            w: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            spacing: 6,
                            p: 0,
                            children: [
                                /*#__PURE__*/ _jsx(VStack, {
                                    w: "100%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    spacing: 0,
                                    p: 6,
                                    children: /*#__PURE__*/ _jsx(InfoIconBold, {
                                        color: "#FF6B2C",
                                        size: "36.67",
                                        display: "block"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(VStack, {
                                    w: "100%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    spacing: 4,
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            fontWeight: "600",
                                            fontSize: "xl",
                                            textAlign: "center",
                                            color: "semantic.onSurface.primary",
                                            children: t('notifications.advance_notification.title')
                                        }),
                                        !!data && !isValidating && !error ? /*#__PURE__*/ _jsx(Text, {
                                            textAlign: "center",
                                            fontSize: "sm",
                                            color: "semantic.onSurface.secondary",
                                            children: /*#__PURE__*/ _jsx(Trans, {
                                                t: t,
                                                ns: "common",
                                                i18nKey: 'notifications.advance_notification.description',
                                                components: [
                                                    /*#__PURE__*/ _jsx("strong", {}, "referenceNumber"),
                                                    /*#__PURE__*/ _jsx("strong", {}, "expiryDate")
                                                ],
                                                values: {
                                                    referenceNumber: data === null || data === void 0 ? void 0 : data.refNo,
                                                    expiryDate: data === null || data === void 0 ? void 0 : data.expireDate
                                                }
                                            })
                                        }) : /*#__PURE__*/ _jsx(Skeleton, {
                                            w: "100%",
                                            h: "80px"
                                        }),
                                        !!data ? /*#__PURE__*/ _jsxs(HStack, {
                                            bg: '#FFEBEB',
                                            borderRadius: '8px',
                                            py: '4px',
                                            px: '8px',
                                            alignItems: 'center',
                                            gap: '8px',
                                            children: [
                                                /*#__PURE__*/ _jsx(Clock, {
                                                    width: "16px",
                                                    height: "16px",
                                                    fill: "#E22417"
                                                }),
                                                /*#__PURE__*/ _jsx(Text, {
                                                    color: '#E22417',
                                                    children: t('notifications.advance_notification.daysLeftLabel', {
                                                        daysLeftLabel: data === null || data === void 0 ? void 0 : data.remindDate
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ _jsx(Skeleton, {
                                            w: "200px",
                                            h: "24px"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    width: "100%",
                                    size: "lg",
                                    onClick: ()=>{
                                        const onSuccessEndRequest = ()=>{
                                            navigate('/bank-plus/customs-services/avans-notification/history?page-number=1&page-size=10');
                                        };
                                        handleMarkAsRead(notification === null || notification === void 0 ? void 0 : notification.id, onSuccessEndRequest);
                                    },
                                    children: t('actions.detailed')
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
